import {
    AVAILABILITY_UPDATE,
    GET_AVAILABILITY_SUCCESS,
    GET_DAY_AVAILABILITY_SUCCESS,
    UPDATE_PARAMS,
} from "./types";

import { availabilityUpdate } from "helpers/reducers";
import { AnyAction } from "redux";
import { APP_LOADED } from "types";

interface IState {
    disabledDays: string[];
    availableDays: string[];
    availabilityParams: any;
    times: { text: string; from: string }[] | [];
    searchParams: any;
    isSelectedDisabled: boolean;
}
function GamesReducer(
    state: IState = {
        disabledDays: [],
        availableDays: [],
        availabilityParams: {},
        times: [],
        searchParams: {},
        isSelectedDisabled: false,
    },
    action = {} as AnyAction
) {
    switch (action.type) {
        case APP_LOADED:
            const date = action.searchParams.date;
            return {
                ...state,
                searchParams: action.searchParams,
                availabilityParams: {
                    date,
                },
            };

        case GET_AVAILABILITY_SUCCESS:
            const data = action.response.data;
            const availableDays = Object.keys(data).filter(
                (key: string) => data[key].available
            );
            const disabledDays = Object.keys(data).filter(
                (key: string) => !data[key].available
            );
            const currentDate = state.searchParams.date;
            return {
                ...state,
                availableDays,
                disabledDays,
                isSelectedDisabled: disabledDays.includes(currentDate),
            };

        case GET_DAY_AVAILABILITY_SUCCESS:
            return {
                ...state,
                ...action.response.data,
            };
        case AVAILABILITY_UPDATE:
            return availabilityUpdate(state, action);

        case UPDATE_PARAMS:
            return {
                ...state,
                searchParams: action.data,
            };
        default:
            return state;
    }
}

export default GamesReducer;
